import { Collapse } from "@mui/material";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { HashContext } from "../HashProvider";
import arrowDown from "../../images/arrow-down.svg";

const getSubcategoryTitle = (sub) => {
  const lang = window.localStorage.getItem("language") || "ru";
  return sub?.[`subcategory_${lang}`] || sub?.subcategory || "";
};

const Category = ({ categoryItems }) => {
  const [expanded, setExpanded] = useState(false);
  const { updateHash } = useContext(HashContext);
  const subcategories = categoryItems?.subcategories || [];
  const hasSubcategories = subcategories.length > 0;

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  const handleCategoryClick = () => {
    updateHash(categoryItems.id);
  };

  return (
    <li className="navbar-category-item">
      <div className="category-parent-row">
        <Link
          to={`/catalog#category-${categoryItems?.id}`}
          className="category-parent-link text-decoration-none"
          onClick={handleCategoryClick}
        >
          {categoryItems?.title}
        </Link>
        {hasSubcategories && (
          <button
            type="button"
            className={`category-toggle ${expanded ? "expanded" : ""}`}
            onClick={handleToggle}
            aria-expanded={expanded}
            aria-label="Toggle subcategories"
          >
            <img src={arrowDown} alt="" className="category-arrow" />
          </button>
        )}
      </div>
      {hasSubcategories && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <ul className="category-subcategory-list">
            {subcategories.map((sub) => (
              <li key={sub.id} className="category-subcategory-item">
                <div className="category-subcategory-row">
                  <Link
                    to={`/catalog#category-${categoryItems.id}`}
                    onClick={handleCategoryClick}
                    className="category-item text-decoration-none"
                  >
                    {getSubcategoryTitle(sub)}
                  </Link>
                  <span className="category-toggle-spacer" aria-hidden="true" />
                </div>
              </li>
            ))}
          </ul>
        </Collapse>
      )}
    </li>
  );
};

export default Category;
